import { UpsertJustifyStrandLoss } from "../../../strand-losses-manager/components/modals/UpsertJustifyStrandLoss";
import {
  STRAND_LOSS_MODAL,
  type StrandLossModal,
} from "../../../strand-losses-manager/hooks/useStrandLossesOptionFunctions";
import { useDataEntryContext } from "../../context/reducer.provider";
import { useCasterDataEntryActions } from "../../hooks/useCasterDataEntryActions";
import { useStrandLossJustify } from "../../hooks/useStrandLossJustify";
import { getStrandAssets } from "../../utils/strand-losses/getStrandAssets";

export const StrandLossJustifyModal = () => {
  const {
    state: { deProcess },
  } = useDataEntryContext();
  const { refreshData } = useCasterDataEntryActions();
  const { selectedStrandLossId, closeStrandLoss } = useStrandLossJustify();

  const strandAssets = getStrandAssets(deProcess?.strands ?? []);
  const parentAssetId = strandAssets[0]?.ParentAssetId ?? null;
  const modal: StrandLossModal =
    selectedStrandLossId === null
      ? STRAND_LOSS_MODAL.CLOSED
      : STRAND_LOSS_MODAL.JUSTIFY;

  return (
    <UpsertJustifyStrandLoss
      showModal={modal}
      onHide={closeStrandLoss}
      onSuccess={refreshData}
      strandLossId={selectedStrandLossId}
      parentAssetId={parentAssetId}
      strandAssets={strandAssets}
    />
  );
};
